import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const menuItems = [
  { group: '', items: [{ path: '/dashboard', label: '🏠 대시보드' }]},
  { group: '데이터 분석', items: [
    { path: '/keyword/multi', label: '키워드 검색량(다중)' },
    { path: '/keyword/related', label: '키워드 검색량(연관)' },
    { path: '/morpheme', label: '형태소 분석기' },
  ]},
  { group: '온라인 데이터', items: [
    { path: '/shopping', label: '쇼핑 순위 조회' },
    { path: '/tracking', label: '순위 변동 추적' },
    { path: '/search', label: '통합검색 분석(다중)' },
    { path: '/search/integrated', label: '통합검색 분석(수집)' },
    { path: '/competitor', label: '경쟁사 비교' },
    { path: '/catalog', label: '원부 순위 추적' },
  { path: '/coupang-rank', label: '쿠팡 순위 조회' },
  { path: '/coupang', label: '쿠팡 순위 추적' },
  ]},
  { group: '플레이스 데이터', items: [
    { path: '/place/rank', label: '플레이스 순위 조회' },
    { path: '/place/tracking', label: '순위 변동 추적' },
    { path: '/place/competitor', label: '경쟁사 분석' },
    { path: '/place/compare', label: '경쟁사 비교' },
  ]},
  { group: '맞춤 마케팅 플랜', items: [
    { path: '/involvement', label: '📌 Step 1. 관여도 진단' },
    { path: '/marketing', label: '📌 Step 2. 마케팅 전략' },
    { path: '/keyword-strategy', label: '📌 Step 3. 키워드 전략' },
    { path: '/report', label: '📌 Step 4. 전략 리포트' },
  ]},
];

const Sidebar = ({ onClose }: { onClose?: () => void }) => {
  const location = useLocation();
  return (
    <div style={{ width: 180, background: '#161B27', padding: '16px 0', height: '100%', overflowY: 'auto' }}>
      {menuItems.map(group => (
        <div key={group.group}>
          <div style={{
            fontSize: 11,
            color: group.group === '맞춤 마케팅 플랜' ? '#F6AD55' : '#B0BAC8',
            padding: group.group === '맞춤 마케팅 플랜' ? '14px 16px 4px' : '12px 16px 4px',
            letterSpacing: '0.05em', fontWeight: 700,
            borderTop: group.group === '맞춤 마케팅 플랜' ? '0.5px solid #F6AD5533' : 'none',
          }}>{group.group === '맞춤 마케팅 플랜' ? '✨ ' + group.group : group.group}</div>
          {group.items.map(item => {
            const active = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path} style={{ textDecoration: 'none' }} onClick={onClose}>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px',
                  fontSize: 12, cursor: 'pointer',
                  color: active ? '#E8ECF4' : (group.group === '맞춤 마케팅 플랜' ? '#D4956A' : '#8892A4'),
                  background: active ? '#1A2035' : 'none',
                  borderLeft: active ? ('2px solid ' + (group.group === '맞춤 마케팅 플랜' ? '#F6AD55' : '#00D4AA')) : '2px solid transparent',
                }}>
                  <div style={{ width: 6, height: 6, borderRadius: '50%', background: active ? (group.group === '맞춤 마케팅 플랜' ? '#F6AD55' : '#00D4AA') : (group.group === '맞춤 마케팅 플랜' ? '#8B6914' : '#4A5568'), flexShrink: 0 }} />
                  {item.label}
                </div>
              </Link>
            );
          })}
        </div>
      ))}
      <div style={{ padding: '16px', borderTop: '0.5px solid #2A3045', marginTop: 8 }}>
        <Link to="/guide" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: '#1A2035', borderRadius: 8, cursor: 'pointer' }}>
            <span style={{ fontSize: 14 }}>📖</span>
            <span style={{ color: '#8892A4', fontSize: 12, fontWeight: 600 }}>사용 가이드</span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default function Layout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [notices, setNotices] = useState<any[]>([]);
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [unread, setUnread] = useState(0);
  const noticeRef = useRef<HTMLDivElement>(null);
  const isLoggedIn = !!(localStorage.getItem('token') || sessionStorage.getItem('token'));
  const [userData, setUserData] = useState<any>(JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || '{}'));
  const user = userData;

  useEffect(() => {
    fetch('/api/notice/list', { headers: { Authorization: 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(d => {
        setNotices(d.notices || []);
        const lastRead = localStorage.getItem('notice_last_read');
        const unreadCount = (d.notices || []).filter((n: any) => !lastRead || n.created_at > lastRead).length;
        setUnread(unreadCount);
      }).catch(() => {});
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      fetch('/api/auth/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(r => r.json()).then(d => {
          if (d.plan) {
            const stored = localStorage.getItem('user');
            const u = JSON.parse(stored || sessionStorage.getItem('user') || '{}');
            u.plan = d.plan;
            u.name = d.name || u.name;
            if (stored) localStorage.setItem('user', JSON.stringify(u));
            else sessionStorage.setItem('user', JSON.stringify(u));
            setUserData(u);
          }
        }).catch(() => {});
    }
  }, []);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (noticeRef.current && !noticeRef.current.contains(e.target as Node)) {
        setNoticeOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleNoticeOpen = () => {
    setNoticeOpen(!noticeOpen);
    if (!noticeOpen) {
      localStorage.setItem('notice_last_read', new Date().toISOString());
      setUnread(0);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#0F1117' }}>
      <style dangerouslySetInnerHTML={{ __html: '.sidebar-pc { display: flex !important; } .hamburger-btn { display: none !important; } @media (max-width: 768px) { .sidebar-pc { display: none !important; } .hamburger-btn { display: flex !important; } }' }} />

      <div style={{ background: '#161B27', borderBottom: '0.5px solid #2A3045', height: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', flexShrink: 0, position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button className="hamburger-btn" onClick={() => setDrawerOpen(!drawerOpen)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, flexDirection: 'column', gap: 4 }}>
            <div style={{ width: 18, height: 2, background: '#8892A4', borderRadius: 2 }} />
            <div style={{ width: 18, height: 2, background: '#8892A4', borderRadius: 2 }} />
            <div style={{ width: 18, height: 2, background: '#8892A4', borderRadius: 2 }} />
          </button>
          <div onClick={() => navigate(isLoggedIn ? '/dashboard' : '/')} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="28" height="28" rx="7" fill="#00D4AA" fillOpacity="0.15"/>
              <path d="M7 20L11 13L14 17L17 10L21 20" stroke="#00D4AA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="21" cy="9" r="2" fill="#00D4AA"/>
              <path d="M7 8H12" stroke="#00D4AA" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M7 11H10" stroke="#00D4AA" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span style={{ color: '#00D4AA', fontSize: 15, fontWeight: 700 }}>SellerRanky</span>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div ref={noticeRef} style={{ position: 'relative' }}>
            <button onClick={handleNoticeOpen} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'relative', padding: 4 }}>
              <span style={{ fontSize: 16 }}>🔔</span>
              {unread > 0 && <span style={{ position: 'absolute', top: 0, right: 0, background: '#F56565', color: '#fff', fontSize: 9, fontWeight: 700, borderRadius: 99, padding: '1px 4px', minWidth: 14, textAlign: 'center' }}>{unread}</span>}
            </button>
            {noticeOpen && (
              <div style={{ position: 'fixed', right: 8, top: 56, width: 'min(300px, calc(100vw - 16px))', background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 8, zIndex: 500, boxShadow: '0 8px 24px rgba(0,0,0,0.4)', maxHeight: '70vh', overflowY: 'auto' }}>
                <div style={{ padding: '12px 16px', borderBottom: '0.5px solid #2A3045', color: '#E8ECF4', fontSize: 13, fontWeight: 600 }}>공지사항</div>
                {notices.length === 0 ? (
                  <div style={{ padding: '20px 16px', color: '#4A5568', fontSize: 13, textAlign: 'center' }}>공지사항이 없습니다</div>
                ) : notices.map((n: any) => (
                  <div key={n.id} style={{ padding: '12px 16px', borderBottom: '0.5px solid #1E2535' }}>
                    <div style={{ color: '#E8ECF4', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{n.title}</div>
                    <div style={{ color: '#8892A4', fontSize: 12, marginBottom: 4, whiteSpace: 'pre-wrap' }}>{n.content}</div>
                    <div style={{ color: '#4A5568', fontSize: 10 }}>{n.created_at?.slice(0, 10)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {isLoggedIn && (
            <>
              <span style={{ fontSize: 10, background: '#0F2A22', color: '#00D4AA', border: '0.5px solid #00D4AA', padding: '2px 8px', borderRadius: 99 }}>{user.plan || 'free'}</span>
              <span onClick={() => navigate('/mypage')} style={{ fontSize: 12, color: '#8892A4', cursor: 'pointer', textDecoration: 'underline' }}>{user.name}</span>
            </>
          )}
          {(!isLoggedIn || user.plan === 'free' || user.plan === 'basic') && (
            <button onClick={() => navigate('/pricing')} style={{ fontSize: 11, background: 'linear-gradient(135deg, #F6AD55, #F56565)', border: 'none', borderRadius: 99, padding: '4px 12px', color: '#0A1F18', fontWeight: 700, cursor: 'pointer' }}>
              ⚡ 업그레이드
            </button>
          )}
          {isLoggedIn ? (
            <button onClick={handleLogout} style={{ fontSize: 11, color: '#8892A4', background: 'none', border: 'none', cursor: 'pointer' }}>로그아웃</button>
          ) : (
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => navigate('/login')} style={{ fontSize: 11, color: '#8892A4', background: 'none', border: '0.5px solid #2A3045', borderRadius: 6, padding: '4px 10px', cursor: 'pointer' }}>로그인</button>
              <button onClick={() => navigate('/register')} style={{ fontSize: 11, background: '#00D4AA', border: 'none', borderRadius: 6, padding: '4px 10px', color: '#0A1F18', fontWeight: 700, cursor: 'pointer' }}>회원가입</button>
            </div>
          )}
        </div>
      </div>

      {drawerOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 200 }}>
          <div onClick={() => setDrawerOpen(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
          <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 200, background: '#161B27', zIndex: 201 }}>
            <Sidebar onClose={() => setDrawerOpen(false)} />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <div className="sidebar-pc" style={{ width: 180, borderRight: '0.5px solid #2A3045', flexShrink: 0 }}>
          <Sidebar />
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
          {children}
        </div>
      </div>

      <footer style={{ borderTop: '0.5px solid #1E2535', padding: '20px 24px', background: '#0A0E17' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, fontSize: 11, color: '#4A5568', lineHeight: 1.8 }}>
          <span style={{ color: '#00D4AA', fontWeight: 700, marginRight: 8 }}>셀러랭키</span>
          <span>상호: 진리커뮤니티</span><span>|</span>
          <span>대표: 김성현</span><span>|</span>
          <span>사업자등록번호: 825-17-00824</span><span>|</span>
          <span>전화: 070-4571-9797</span><span>|</span>
          <span>업태: 서비스 | 종목: 온라인정보제공업</span>
          <span style={{ width: '100%', display: 'block' }}>주소: 전북특별자치도 전주시 덕진구 기린대로 945-6, 경제통상진흥원 소상공인희망센터 107호</span>
          <span>이메일: sellerranky@gmail.com</span>
          <span style={{ width: '100%', display: 'block', marginTop: 4 }}>
            <a href="/privacy" style={{ color: '#8892A4', fontSize: 11, textDecoration: 'none', marginRight: 12 }}>개인정보처리방침</a>
            <span style={{ color: '#2A3045', marginRight: 12 }}>|</span>
            <a href="/terms" style={{ color: '#8892A4', fontSize: 11, textDecoration: 'none', marginRight: 12 }}>이용약관</a>
            <span style={{ color: '#2A3045', marginRight: 12 }}>|</span>
            <span style={{ color: '#2A3045', fontSize: 11 }}>© 2026 SellerRanky. All rights reserved.</span>
          </span>
        </div>
      </footer>
    </div>
  );
}
